"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelSubjectSchema = void 0;
exports.parsePanelSubject = parsePanelSubject;
const zod_1 = require("zod");
const panel_language_1 = require("./panel-language");
const hash_1 = require("./hash");
const image_file_1 = require("./image-file");
const subject_level_1 = require("./subject-level");
const content_visit_info_1 = require("./content-visit-info");
const subject_stats_1 = require("./subject-stats");
exports.PanelSubjectSchema = zod_1.z.object({
  id: zod_1.z.number(),
  slug: zod_1.z.string().optional(),
  code: zod_1.z.string(),
  title: zod_1.z.string().trim(),
  category_id: zod_1.z.number(),
  language_id: zod_1.z.number(),
  language: panel_language_1.PanelLanguageSchema.optional(),
  levels_category_id: zod_1.z.number().optional(),
  levels: zod_1.z.array(subject_level_1.SubjectLevelSchema).optional(),
  banner: (0, hash_1.hashSchema)(image_file_1.imageFileSchema).optional(),
  cover_id: zod_1.z.string().optional(),
  cover: (0, hash_1.hashSchema)(image_file_1.imageFileSchema).optional(),
  visit_info: content_visit_info_1.ContentVisitInfoSchema.partial().optional(),
  stats: subject_stats_1.SubjectStatsSchema.partial().optional()
});
function parsePanelSubject(values) {
  return exports.PanelSubjectSchema.parse(values);
}
